/**
 * Données des pages services — SEO Luxury Wood
 * Chaque service a du contenu unique, des FAQ et des mots-clés ciblés
 */

export const serviceData = {
  'cuisines-sur-mesure': {
    slug: 'cuisines-sur-mesure',
    titleFr: 'Cuisines Sur Mesure',
    titleAr: 'مطابخ حسب الطلب',
    seoTitleFr: 'Cuisines Sur Mesure au Maroc — Luxury Wood Concept',
    seoTitleAr: 'مطابخ حسب الطلب في المغرب — لاكشري وود كونسيبت',
    seoDescFr: 'Fabrication de cuisines sur mesure haut de gamme au Maroc. Bois massif, laqué, stratifié — designs modernes et traditionnels. Devis gratuit à Rabat, Casablanca, Marrakech.',
    seoDescAr: 'تصنيع مطابخ فاخرة حسب الطلب في المغرب. خشب طبيعي، لاك، استراتيفي — تصاميم عصرية وتقليدية. عرض سعر مجاني في الرباط، الدار البيضاء، مراكش.',
    heroImage: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&q=80&w=1200',
    category: 'Cuisine',
    
    contentFr: `La cuisine est le cœur de la maison. Chez Luxury Wood Concept, nous concevons des cuisines sur mesure qui allient fonctionnalité et esthétique, adaptées à votre espace et à votre style de vie.

**Nos styles de cuisines :**
- **Cuisine moderne** : lignes épurées, surfaces lisses, éclairage LED intégré
- **Cuisine classique** : portes moulurées, finitions patinées, plans de travail en marbre
- **Cuisine marocaine** : intégration du zellige, arcs traditionnels revisités
- **Cuisine ouverte** : îlot central, bar convivial, rangements optimisés

**Matériaux proposés :**
- Bois massif (chêne, noyer, hêtre)
- MDF hydrofuge laqué haute brillance
- Stratifié haute résistance
- Plans de travail : granit, quartz, marbre, solid surface

Chaque cuisine est conçue en 3D avant fabrication, vous permettant de visualiser le résultat final et d'ajuster chaque détail.`,

    contentAr: `المطبخ هو قلب المنزل. في لاكشري وود كونسيبت، نصمم مطابخ حسب الطلب تجمع بين الوظيفية والجمالية، مكيفة مع فضائكم وأسلوب حياتكم.

**أنماط مطابخنا:**
- **مطبخ عصري**: خطوط نقية، أسطح ملساء، إضاءة LED مدمجة
- **مطبخ كلاسيكي**: أبواب مزخرفة، تشطيبات عتيقة، أسطح عمل من الرخام
- **مطبخ مغربي**: دمج الزليج، أقواس تقليدية معاصرة
- **مطبخ مفتوح**: جزيرة مركزية، بار اجتماعي، تخزين محسن`,

    faqFr: [
      { q: 'Quel est le prix moyen d\'une cuisine sur mesure au Maroc ?', a: 'Le prix varie selon les matériaux, les dimensions et les équipements. Comptez entre 25 000 et 120 000 MAD pour une cuisine complète. Nous établissons un devis gratuit et détaillé après visite.' },
      { q: 'Quel est le délai de fabrication ?', a: 'Comptez entre 3 et 6 semaines selon la complexité du projet, après validation du plan 3D.' },
      { q: 'Proposez-vous l\'électroménager ?', a: 'Nous nous chargeons de l\'intégration de vos appareils électroménagers dans le design de la cuisine. Nous pouvons vous conseiller sur les marques et modèles adaptés.' },
      { q: 'Faites-vous des cuisines pour les petits espaces ?', a: 'Absolument. Nous sommes spécialisés dans l\'optimisation de l\'espace. Une petite cuisine bien conçue peut être aussi fonctionnelle qu\'une grande.' },
    ],
    faqAr: [
      { q: 'ما هو متوسط سعر مطبخ حسب الطلب في المغرب؟', a: 'يختلف السعر حسب المواد والأبعاد والتجهيزات. يتراوح بين 25,000 و 120,000 درهم لمطبخ كامل. نقدم عرض سعر مجاني ومفصل بعد الزيارة.' },
      { q: 'ما هي مدة التصنيع؟', a: 'تتراوح بين 3 و 6 أسابيع حسب تعقيد المشروع، بعد المصادقة على التصميم ثلاثي الأبعاد.' },
      { q: 'هل توفرون الأجهزة الكهرومنزلية؟', a: 'نتكفل بدمج أجهزتكم الكهرومنزلية في تصميم المطبخ. يمكننا نصحكم حول العلامات والأنماط المناسبة.' },
      { q: 'هل تصنعون مطابخ للمساحات الصغيرة؟', a: 'بالتأكيد. نحن متخصصون في تحسين الفضاء. مطبخ صغير مصمم جيداً يمكن أن يكون وظيفياً كمطبخ كبير.' },
    ],

    keywords: ['cuisine sur mesure maroc', 'cuisine sur mesure rabat', 'cuisine équipée casablanca', 'cuisine moderne maroc', 'cuisine bois massif maroc', 'cuisiniste rabat', 'prix cuisine sur mesure maroc'],
  },

  'portes-interieures': {
    slug: 'portes-interieures',
    titleFr: 'Portes Intérieures',
    titleAr: 'أبواب داخلية',
    seoTitleFr: 'Portes Intérieures Sur Mesure — Luxury Wood Concept Maroc',
    seoTitleAr: 'أبواب داخلية حسب الطلب — لاكشري وود كونسيبت المغرب',
    seoDescFr: 'Portes intérieures en bois massif sur mesure au Maroc. Modèles classiques, modernes et marocains. Fabrication artisanale, livraison et pose partout au Maroc.',
    seoDescAr: 'أبواب داخلية من الخشب الطبيعي حسب الطلب في المغرب. نماذج كلاسيكية، عصرية ومغربية. صناعة حرفية، توصيل وتركيب في جميع أنحاء المغرب.',
    heroImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?auto=format&fit=crop&q=80&w=1200',
    category: 'Porte',
    
    contentFr: `Les portes intérieures définissent le caractère de chaque pièce. Luxury Wood Concept fabrique des portes en bois massif et semi-massif sur mesure, adaptées à l'architecture de votre espace.

**Nos types de portes intérieures :**
- **Porte battante classique** : le choix intemporel pour toutes les pièces
- **Porte coulissante** : gain de place élégant, idéale pour les petits espaces
- **Porte à galandage** : disparaît dans le mur, solution premium
- **Porte vitrée** : apporte la lumière tout en préservant l'intimité
- **Porte à double vantail** : entrée majestueuse pour salons et séjours

**Finitions disponibles :**
- Bois naturel verni mat ou brillant
- Laqué (toutes couleurs RAL)
- Teinté noyer, chêne, wengé
- Moucharabieh contemporain`,

    contentAr: `الأبواب الداخلية تحدد طابع كل غرفة. لاكشري وود كونسيبت يصنع أبواباً من الخشب الطبيعي وشبه الطبيعي حسب الطلب، مكيفة مع هندسة فضائكم.`,

    faqFr: [
      { q: 'Quel type de bois recommandez-vous pour les portes intérieures ?', a: 'Le hêtre et le chêne sont les plus résistants et durables. Pour un budget maîtrisé, le MDF revêtu offre un excellent rapport qualité/prix.' },
      { q: 'La pose est-elle incluse ?', a: 'Oui, nous assurons la livraison et la pose professionnelle par notre équipe. Le prix inclut la quincaillerie (poignées, charnières).' },
      { q: 'Quelles dimensions proposez-vous ?', a: 'C\'est du sur mesure : toutes les dimensions sont possibles, y compris les portes grand format (2.40m+) pour les villas.' },
    ],
    faqAr: [
      { q: 'أي نوع من الخشب تنصحون به للأبواب الداخلية؟', a: 'الزان والبلوط هما الأكثر مقاومة ومتانة. لميزانية محدودة، MDF المغطى يقدم نسبة جودة/سعر ممتازة.' },
      { q: 'هل التركيب متضمن؟', a: 'نعم، نضمن التوصيل والتركيب المهني من طرف فريقنا. السعر يشمل الأدوات (المقابض، المفصلات).' },
    ],

    keywords: ['porte intérieure bois maroc', 'porte sur mesure rabat', 'porte bois massif', 'porte coulissante maroc', 'porte intérieure casablanca'],
  },

  'portes-entree': {
    slug: 'portes-entree',
    titleFr: 'Portes d\'Entrée',
    titleAr: 'أبواب المدخل',
    seoTitleFr: 'Portes d\'Entrée Sur Mesure et Blindées — Luxury Wood Concept Maroc',
    seoTitleAr: 'أبواب مدخل حسب الطلب ومصفحة — لاكشري وود كونسيبت المغرب',
    seoDescFr: 'Portes d\'entrée en bois massif, blindées et design au Maroc. Sécurité maximale et esthétique haut de gamme. Fabrication artisanale Luxury Wood Concept.',
    heroImage: 'https://images.unsplash.com/photo-1517466787929-bc90951d0974?auto=format&fit=crop&q=80&w=1200',
    category: 'Porte',
    
    contentFr: `Votre porte d'entrée est la première impression de votre intérieur. Luxury Wood Concept fabrique des portes d'entrée en bois massif qui allient sécurité maximal et esthétique haut de gamme.

**Nos gammes :**
- **Porte blindée bois** : structure acier + habillage bois noble
- **Porte massive traditionnelle** : bois sculpté, cloutage artisanal
- **Porte design contemporaine** : lignes épurées, mix bois/aluminium/verre
- **Porte imposte** : avec vitrage décoratif supérieur`,

    contentAr: `باب المدخل هو الانطباع الأول لداخلكم. لاكشري وود كونسيبت يصنع أبواب مدخل من الخشب الطبيعي تجمع بين الأمان الأقصى والجمالية الفاخرة.`,

    faqFr: [
      { q: 'Vos portes d\'entrée sont-elles sécurisées ?', a: 'Oui, nos portes blindées intègrent une structure en acier avec serrure multipoints, tout en conservant l\'esthétique du bois noble.' },
      { q: 'Résistent-elles aux conditions climatiques marocaines ?', a: 'Absolument. Tous nos bois sont traités contre l\'humidité et les UV pour résister au climat marocain.' },
    ],
    faqAr: [],

    keywords: ['porte entrée bois maroc', 'porte blindée bois', 'porte entrée luxe maroc', 'porte entrée sur mesure', 'porte entrée villa'],
  },

  'dressings': {
    slug: 'dressings',
    titleFr: 'Dressings & Placards',
    titleAr: 'خزائن وغرف ملابس',
    seoTitleFr: 'Dressings et Placards Sur Mesure — Luxury Wood Concept Maroc',
    seoTitleAr: 'خزائن وغرف ملابس حسب الطلب — لاكشري وود كونسيبت المغرب',
    seoDescFr: 'Dressings sur mesure, placards intégrés et walk-in closets au Maroc. Optimisation de l\'espace et rangement intelligent. Devis gratuit.',
    heroImage: 'https://images.unsplash.com/photo-1558997519-83ea9252edf8?auto=format&fit=crop&q=80&w=1200',
    category: 'Dressing',
    
    contentFr: `Un dressing bien conçu transforme votre quotidien. Luxury Wood Concept crée des solutions de rangement sur mesure qui optimisent chaque centimètre de votre espace.

**Nos solutions :**
- **Dressing ouvert** : concept loft, étagères et penderies visibles
- **Dressing fermé** : portes coulissantes ou battantes, intérieur organisé
- **Walk-in closet** : la pièce dédiée, le summum du luxe
- **Placard intégré** : sous pente, sous escalier, niche murale`,

    contentAr: `خزانة مصممة بعناية تحول يومياتكم. لاكشري وود كونسيبت يصنع حلول تخزين حسب الطلب تحسن كل سنتيمتر من فضائكم.`,

    faqFr: [
      { q: 'Pouvez-vous aménager un dressing dans un espace réduit ?', a: 'Oui, c\'est notre spécialité. Nous exploitons chaque recoin : sous-pente, angles, niches murales.' },
      { q: 'Quels accessoires intégrez-vous ?', a: 'Tiroirs à bijoux, porte-chaussures, éclairage LED automatique, miroirs intégrés, tringles coulissantes.' },
    ],
    faqAr: [],

    keywords: ['dressing sur mesure maroc', 'dressing casablanca', 'placard intégré rabat', 'walk-in closet maroc', 'rangement sur mesure'],
  },

  'parquet-bois': {
    slug: 'parquet-bois',
    icon: '🪵',
    titleFr: 'Parquet & Revêtement Bois',
    titleAr: 'باركيه وتغطية خشبية',
    seoTitleFr: 'Parquet Bois Massif et Stratifié au Maroc — Luxury Wood Concept',
    seoTitleAr: 'باركيه خشب طبيعي واستراتيفي في المغرب — لاكشري وود كونسيبت',
    seoDescFr: 'Pose de parquet bois massif, contrecollé et stratifié au Maroc. Finitions chêne, noyer, bambou. Installation professionnelle Luxury Wood Concept.',
    heroImage: 'https://images.unsplash.com/photo-1615971677499-5467cbab01c0?auto=format&fit=crop&q=80&w=1200',
    category: 'Parquet',
    
    contentFr: `Le parquet en bois apporte une chaleur et une noblesse incomparables à tout intérieur. Luxury Wood Concept propose une gamme complète de parquets, de la pose à la finition.

**Nos types de parquet :**
- **Parquet massif** : chêne, noyer, hêtre — le choix de la durabilité
- **Parquet contrecollé** : stabilité dimensionnelle, compatible chauffage au sol
- **Parquet stratifié** : rapport qualité/prix optimal, large choix de décors
- **Parquet bambou** : écologique et résistant, tendance moderne`,

    contentAr: `الباركيه الخشبي يجلب دفئاً ونبلاً لا مثيل لهما لأي داخلي. لاكشري وود كونسيبت يقدم مجموعة كاملة من الباركيه، من التركيب إلى التشطيب.`,

    faqFr: [
      { q: 'Le parquet résiste-t-il au climat marocain ?', a: 'Oui, nous recommandons le parquet contrecollé ou stratifié pour les régions chaudes. Le traitement anti-humidité est systématique.' },
    ],
    faqAr: [],
    keywords: ['parquet bois massif maroc', 'parquet rabat', 'parquet stratifié casablanca', 'pose parquet maroc'],
  },

  'salon-marocain': {
    slug: 'salon-marocain',
    titleFr: 'Salon Marocain & Beldi',
    titleAr: 'صالون مغربي',
    seoTitleFr: 'Salon Marocain Moderne et Beldi Sur Mesure — Luxury Wood Concept',
    seoTitleAr: 'صالون مغربي عصري وبلدي حسب الطلب — لاكشري وود كونسيبت',
    seoDescFr: 'Création de salons marocains modernes et beldi sur mesure. Bois sculpté, zellige, tadelakt. Un mariage entre tradition et modernité. Luxury Wood Concept.',
    heroImage: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&q=80&w=1200',
    category: 'Salon',
    
    contentFr: `Le salon marocain est l'âme de la maison. Luxury Wood Concept revisite cette tradition ancestrale avec des créations sur mesure qui marient le bois noble aux éléments décoratifs du patrimoine marocain.

**Nos créations :**
- **Salon beldi revisité** : bois sculpté + tissus modernes
- **Salon contemporain marocain** : lignes épurées, touches traditionnelles subtiles
- **Salon d'apparat** : plafonds en bois sculpté, moucharabiehs, zellige`,

    contentAr: `الصالون المغربي هو روح المنزل. لاكشري وود كونسيبت يعيد ابتكار هذا التقليد العريق بإبداعات حسب الطلب تزاوج بين الخشب النبيل والعناصر الزخرفية من التراث المغربي.`,

    faqFr: [
      { q: 'Pouvez-vous intégrer du zellige et du bois dans un salon moderne ?', a: 'Absolument, c\'est notre signature. Nous marions le zellige artisanal avec des boiseries contemporaines pour un résultat unique.' },
    ],
    faqAr: [],
    keywords: ['salon marocain moderne', 'salon beldi bois', 'salon marocain sur mesure', 'salon marocain rabat', 'décoration salon marocain'],
  },

  'amenagement-villa': {
    slug: 'amenagement-villa',
    titleFr: 'Aménagement de Villas',
    titleAr: 'تجهيز الفلل',
    seoTitleFr: 'Aménagement Intérieur de Villas de Luxe — Luxury Wood Concept Maroc',
    seoTitleAr: 'تجهيز داخلي للفلل الفاخرة — لاكشري وود كونسيبت المغرب',
    seoDescFr: 'Aménagement complet de villas de luxe au Maroc. Menuiserie intérieure, cuisines, dressings, escaliers, parquet. Un interlocuteur unique pour tout le bois de votre villa.',
    heroImage: '/images/villas-prestigia.webp',
    category: 'Villa',
    
    contentFr: `L'aménagement d'une villa est un projet d'envergure qui mérite un partenaire de confiance. Luxury Wood Concept intervient comme interlocuteur unique pour tous les travaux de menuiserie et d'aménagement bois de votre villa.

**Notre offre villa complète :**
- Cuisine sur mesure (design + fabrication + pose)
- Toutes les portes intérieures et extérieures
- Dressings et placards intégrés
- Escalier sur mesure
- Parquet et lambris
- Bibliothèques et meubles TV
- Salon marocain

Un seul interlocuteur, une cohérence esthétique garantie.`,

    contentAr: `تجهيز فيلا هو مشروع كبير يستحق شريكاً موثوقاً. لاكشري وود كونسيبت يتدخل كمحاور وحيد لجميع أعمال النجارة والتجهيز الخشبي لفيلاتكم.`,

    faqFr: [
      { q: 'Intervenez-vous sur des villas en construction ou uniquement en rénovation ?', a: 'Les deux. Idéalement, nous intervenons dès la phase plans pour optimiser les emplacements et les dimensions.' },
      { q: 'Quel est le délai pour l\'aménagement complet d\'une villa ?', a: 'Entre 2 et 4 mois selon la taille et la complexité du projet.' },
    ],
    faqAr: [],
    keywords: ['aménagement villa maroc', 'aménagement villa luxe', 'villa sur mesure rabat', 'menuiserie villa casablanca', 'aménagement intérieur villa marrakech'],
  },

  'amenagement-bureau': {
    slug: 'amenagement-bureau',
    titleFr: 'Aménagement de Bureaux',
    titleAr: 'تجهيز المكاتب',
    seoTitleFr: 'Aménagement de Bureaux Professionnels — Luxury Wood Concept Maroc',
    seoTitleAr: 'تجهيز مكاتب مهنية — لاكشري وود كونسيبت المغرب',
    seoDescFr: 'Aménagement de bureaux et espaces professionnels au Maroc. Mobilier sur mesure, postes de travail, salles de réunion, accueil. B2B.',
    heroImage: '/images/bureaux.webp',
    category: 'Bureau',
    
    contentFr: `Un espace de travail bien conçu booste la productivité et reflète le professionnalisme de votre entreprise. Luxury Wood Concept aménage vos bureaux avec du mobilier sur mesure haut de gamme.

**Nos services bureaux :**
- Postes de travail et open spaces
- Bureaux de direction
- Salles de réunion et boardrooms
- Accueil et espaces d'attente
- Rangements et archives
- Cloisons acoustiques en bois`,

    contentAr: `فضاء عمل مصمم بعناية يعزز الإنتاجية ويعكس احترافية مؤسستكم. لاكشري وود كونسيبت يجهز مكاتبكم بأثاث حسب الطلب فاخر.`,

    faqFr: [
      { q: 'Travaillez-vous avec des entreprises et des promoteurs ?', a: 'Oui, nous avons une offre B2B dédiée avec des conditions adaptées aux volumes importants et aux projets multi-sites.' },
    ],
    faqAr: [],
    keywords: ['aménagement bureau casablanca', 'bureau professionnel maroc', 'mobilier bureau sur mesure', 'bureau direction rabat'],
  },

  'amenagement-restaurant': {
    slug: 'amenagement-restaurant',
    titleFr: 'Aménagement Restaurant & Café',
    titleAr: 'تجهيز المطاعم والمقاهي',
    seoTitleFr: 'Aménagement de Restaurants et Cafés — Luxury Wood Concept Maroc',
    seoTitleAr: 'تجهيز المطاعم والمقاهي — لاكشري وود كونسيبت المغرب',
    seoDescFr: 'Aménagement de restaurants, cafés et espaces de restauration au Maroc. Mobilier sur mesure, bar, comptoir, terrasse. Atmosphère unique garantie.',
    heroImage: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&q=80&w=900',
    category: 'Restaurant',
    
    contentFr: `L'aménagement d'un restaurant ou d'un café est un investissement stratégique. L'atmosphère que vous créez est votre premier argument commercial. Luxury Wood Concept conçoit des espaces de restauration uniques et mémorables.

**Nos prestations :**
- Comptoirs et bars sur mesure
- Tables et mobilier de salle
- Banquettes et alcôves
- Terrasses couvertes en bois
- Décoration murale en bois
- Cuisine professionnelle intégrée`,

    contentAr: `تجهيز مطعم أو مقهى هو استثمار استراتيجي. الأجواء التي تخلقونها هي حجتكم التجارية الأولى.`,

    faqFr: [],
    faqAr: [],
    keywords: ['aménagement restaurant maroc', 'aménagement café casablanca', 'mobilier restaurant', 'décoration restaurant bois'],
  },

  'amenagement-pharmacie': {
    slug: 'amenagement-pharmacie',
    titleFr: 'Aménagement Pharmacie & Parapharmacie',
    titleAr: 'تجهيز الصيدليات',
    seoTitleFr: 'Aménagement de Pharmacies et Parapharmacies — Luxury Wood Concept Maroc',
    seoTitleAr: 'تجهيز الصيدليات — لاكشري وود كونسيبت المغرب',
    seoDescFr: 'Aménagement de pharmacies et parapharmacies au Maroc. Rayonnages, comptoirs, éclairage et signalétique sur mesure. Normes professionnelles respectées.',
    heroImage: '/images/pharmacie.webp',
    category: 'Pharmacie',
    
    contentFr: `L'aménagement d'une pharmacie exige une expertise technique spécifique. Luxury Wood Concept combine fonctionnalité, ergonomie et esthétique pour créer des officines modernes et accueillantes.

**Nos solutions pharmacie :**
- Rayonnages muraux et îlots centraux
- Comptoir de dispensation
- Zone parapharmacie premium
- Éclairage technique adapté
- Signalétique et habillage vitrine`,

    contentAr: `تجهيز صيدلية يتطلب خبرة تقنية محددة. لاكشري وود كونسيبت يجمع بين الوظيفية والأرغونومية والجمالية لإنشاء صيدليات عصرية ومرحبة.`,

    faqFr: [],
    faqAr: [],
    keywords: ['aménagement pharmacie maroc', 'meuble pharmacie', 'rayonnage pharmacie', 'comptoir pharmacie sur mesure'],
  },

  'meuble-tv': {
    slug: 'meuble-tv',
    titleFr: 'Meubles TV & Bibliothèques',
    titleAr: 'أثاث التلفاز والمكتبات',
    seoTitleFr: 'Meubles TV et Bibliothèques Sur Mesure — Luxury Wood Concept Maroc',
    seoTitleAr: 'أثاث التلفاز والمكتبات حسب الطلب — لاكشري وود كونسيبت المغرب',
    seoDescFr: 'Meubles TV sur mesure, bibliothèques murales et étagères en bois au Maroc. Design contemporain ou classique. Fabrication artisanale Luxury Wood.',
    heroImage: 'https://images.unsplash.com/photo-1593062096033-9a26b09da705?auto=format&fit=crop&q=80&w=1200',
    category: 'Meuble TV',
    
    contentFr: `Le meuble TV est devenu la pièce maîtresse du salon moderne. Luxury Wood Concept crée des meubles TV et des bibliothèques murales sur mesure qui subliment votre espace.

**Nos créations :**
- Meuble TV suspendu avec éclairage LED
- Ensemble mural bibliothèque + TV
- Meuble TV encastré dans niche
- Bibliothèque murale toute hauteur`,

    contentAr: `أثاث التلفاز أصبح القطعة المركزية في الصالون العصري. لاكشري وود كونسيبت يصنع أثاث تلفاز ومكتبات حائطية حسب الطلب تضفي جمالاً على فضائكم.`,

    faqFr: [],
    faqAr: [],
    keywords: ['meuble TV sur mesure maroc', 'meuble TV moderne', 'bibliothèque murale bois', 'meuble salon maroc'],
  },

  'escaliers-bois': {
    slug: 'escaliers-bois',
    icon: '🪜',
    titleFr: 'Escaliers en Bois',
    titleAr: 'سلالم خشبية',
    seoTitleFr: 'Escaliers en Bois Massif Sur Mesure — Luxury Wood Concept Maroc',
    seoTitleAr: 'سلالم خشبية حسب الطلب — لاكشري وود كونسيبت المغرب',
    seoDescFr: 'Escaliers en bois massif sur mesure au Maroc. Droit, quart tournant, hélicoïdal. Garde-corps et rampes en bois noble. Fabrication et pose Luxury Wood.',
    heroImage: 'https://images.unsplash.com/photo-1572025442646-866d16c84a54?auto=format&fit=crop&q=80&w=1200',
    category: 'Escalier',

    contentFr: `L'escalier est bien plus qu'un élément fonctionnel — c'est une pièce architecturale qui structure tout votre espace. Luxury Wood Concept conçoit et fabrique des escaliers en bois massif sur mesure.

**Nos types d'escaliers :**
- Escalier droit
- Quart tournant et demi tournant
- Escalier hélicoïdal / colimaçon
- Escalier suspendu (marches flottantes)
- Garde-corps et rampes en bois`,

    contentAr: `السلم أكثر من عنصر وظيفي — إنه قطعة معمارية تهيكل كل فضائكم.`,

    faqFr: [],
    faqAr: [],
    keywords: ['escalier bois massif maroc', 'escalier sur mesure rabat', 'escalier bois casablanca', 'rampe escalier bois'],
  },
};

// Liste ordonnée pour la navigation
export const serviceList = [
  'cuisines-sur-mesure',
  'portes-interieures',
  'portes-entree',
  'dressings',
  'parquet-bois',
  'salon-marocain',
  'amenagement-villa',
  'amenagement-bureau',
  'amenagement-restaurant',
  'amenagement-pharmacie',
  'meuble-tv',
  'escaliers-bois',
];

export default serviceData;
